import React, { Component } from 'react'
import { Grid, Icon, Form, Menu, Label, Tab, Image, Popup, Header, Input } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';
import { source } from 'react-aim';
import { toastr } from 'react-redux-toastr';
import { Container } from 'react-smooth-dnd';
import EllipsisTooltip from '../../../../common/EllipsisTooltip';
import convertIcon from '../../../../../helpers/convert-Icon';
import NoSearchFoundImage from '../../../../../images/grafix-banner/gfx-no-results.svg';

@source({
    mouseEnter: (props, component) => {
        dispatch.app.setHelpContext(props.name)
    }
})

class ReferencesList extends Component {

    removeReference(itemData, activityData) {

        let item = itemData && itemData.id && itemData.id._id ? itemData.id : itemData

        let message = <div className="confirmMessage">
            <h3>Delete Reference</h3>
            <label>{item.name}</label>
            <p>Are you sure that you wish to delete this reference?</p>
            <span >This action is not reversible</span>
        </div>

        toastr.confirm(message, {
            onOk: () => {
                var index = activityData.references.findIndex((element, i) => {
                    return element.id._id === item._id
                });
                activityData.removedRef = item._id;
                if(activityData.initiativeId && activityData.initiativeId.status && activityData.initiativeId.status == 4){
                    activityData.activityReferenceId = activityData.references[index]
                }
                activityData.references.splice(index, 1)
                dispatch.initiatives.editActivityAsync(activityData)
            }
        });
    }

    render() {
        const { contentList, activity, type, selectedDataById ,selectedActivityData} = this.props;

        let contentItem = contentList && contentList.id && contentList.id._id ? contentList.id : contentList

        return <div className="divBox display-flex-root" style={{height:"33px"}} >
            <div className="float-left" style={{ width: "calc(100% - 140px)" }}>
                <a target="_blank" rel="noopener noreferrer" href={contentList.id.contentpath && contentList.id.contentpath.indexOf('://') === -1 ? 'http://' + contentList.id.contentpath : contentList.id.contentpath}>
                    <Icon name={convertIcon(contentItem.type)} />
                </a>&nbsp; &nbsp;
                <EllipsisTooltip
                    className="float-left" style={{ width: "calc(100% - 40px)" }}
                    name={contentItem.name}
                    deprecated={contentItem.deleted}
                    // name={contentItem.deleted ? `${contentItem.name} (deprecated)` : contentItem.name}
                />
            </div>

            <div className="float-right text-right" style={{ width: "140px" }}>
                <span style={{ color: '#bababc' }} > {contentItem.scope ? contentItem.scope === "Private" ? "Workspace" : contentItem.scope : contentItem.scope === "Private" ? "Workspace" : contentItem.scope} </span> &nbsp; &nbsp;
                {contentItem.createdBy && contentItem.createdBy.profilePic ?
                    <Popup
                        className="popupStyled"
                        inverted
                        trigger={
                            <Image avatar src={contentItem.createdBy.profilePic} />
                        }
                        position="top right"
                        content={<span>{contentItem.createdBy.firstName} {contentItem.createdBy.lastName}</span>}
                    />
                    : null}

                {type === "phase" || type === "stage" ?
                    null :
                    selectedActivityData.runStatus === 0 || selectedActivityData.runStatus === 1 || selectedActivityData.runStatus === 4 ?
                        <Icon
                            className="close-icon"
                            name="close"
                            onClick={() => this.removeReference(contentItem, activity)} /> : null}
                    &nbsp; &nbsp;
                </div>
        </div>;
    }
}

class CommunityActivityResourcePaneForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeIndex: 0
        }

    }


    onDragEnd = (result) => {
        this.setState({ name: null })
        // const { handleDragEnd, boardId } = this.props;
        const { addedIndex, payload } = result;
        if (addedIndex != null) {
            if (payload.draggableType === "content") {
                payload.isRequired = true;
                let checkName = this.props.selectedActivityData.references.filter((item) => { return item.id._id === payload.id })

                if (checkName.length > 0) {
                    toastr.error('Message', 'Content already present.')
                } else {
                    (this.props.selectedActivityData.references).push(payload)
                    dispatch.initiatives.editActivityAsync(this.props.selectedActivityData)
                    // dispatch.initiatives.setreferenceContentDataAsync([payload]);
                }
            }
        }
    }
    shouldAcceptDrop = sourceContainerOptions => {
        const accessDrop = sourceContainerOptions.groupName === 'Content'

        return accessDrop
    }

    handleTabChange = (e, data) => {
        this.setState({ activeIndex: data.activeIndex })
        this.setState({ name: '' })
    }

    componentWillReceiveProps(newProps) {
        if (this.props.selectedActivityData) {
            this.setState({ activityName: newProps.selectedActivityData.name })
            if (this.props.selectedActivityData.parentActivity) {
                this.setState({ phaseName: this.props.selectedActivityData.parentActivity.name })
                this.setState({ stageName: newProps.selectedActivityData.name })
                if (this.props.selectedActivityData.parentActivity.parentActivity) {
                    this.setState({ phaseName: this.props.selectedActivityData.parentActivity.parentActivity.name })
                    this.setState({ stageName: this.props.selectedActivityData.parentActivity.name })
                }
            }
        }

    }


    render() {

        

        const { selectedActivityData, selectedDataById } = this.props

        const { activeIndex } = this.state

        let initiativeData;
        if (this.props.activeTab === 'myactivities') {
            initiativeData = this.props.selectedActivityData.initiativeId;
        } else {
            initiativeData = this.props.selectedDataById;
        }

        let NoReferencesComponent = <div fluid className="w_100 " style={{ padding: "10px 0" }}>
            <Image src={NoSearchFoundImage} size='small' centered={true} />
            <Header as='h3' icon textAlign='center'>
                <Header.Content >
                    Nothing to show!
            <br />  <br />
                </Header.Content>
            </Header>
        </div>


        //Phase
        let isParentActivity = selectedActivityData && selectedActivityData.parentActivity
        let phaseRefCheck;
        if (isParentActivity && isParentActivity.parentActivity) {
            phaseRefCheck = isParentActivity &&
                isParentActivity.parentActivity;
        } else {
            phaseRefCheck = isParentActivity
        }

        let PhaseComponent = phaseRefCheck && phaseRefCheck.references && phaseRefCheck.references.length !== 0 ?
            phaseRefCheck.references
                .filter((f, i) => { return this.state.name && activeIndex === 2 ? f.id.name.toLowerCase().includes(this.state.name.toLowerCase()) : f })
                .map((reference, index) => {
                    return <ReferencesList
                        key={index}
                        selectedDataById={selectedDataById}
                        type="phase"
                        contentList={reference}
                        activity={phaseRefCheck} />
                })
            : []


        //Stage
        let StageRefCheck;
        if (isParentActivity && isParentActivity.parentActivity) {
            StageRefCheck = isParentActivity
        } else {
            StageRefCheck = []
        }

        let StageComponent = StageRefCheck && StageRefCheck.references && StageRefCheck.references.length !== 0 ?
            StageRefCheck.references
                .filter((f, i) => { return this.state.name && activeIndex === 1 ? f.id.name.toLowerCase().includes(this.state.name.toLowerCase()) : f })
                .map((reference, index) => {
                    return <ReferencesList key={index} selectedDataById={selectedDataById} type="stage" contentList={reference} activity={StageRefCheck} />
                }) : []


        //Activity
        let ActivityComponent = selectedActivityData.references &&
            selectedActivityData.references.length !== 0 ?
            selectedActivityData.references
                .filter((f, i) => { return this.state.name && activeIndex === 0 ? f.id.name.toLowerCase().includes(this.state.name.toLowerCase()) : f })
                .map((reference, index) => {
                    return <ReferencesList key={index} selectedDataById={selectedDataById} selectedActivityData={selectedActivityData} type="activity" contentList={reference} activity={selectedActivityData} />
                }) : []

        let searchByName = <Input
            className="w_100"
            placeholder='Search by Content name'
            value={this.state.name}
            onChange={(e) => this.setState({ name: e.target.value })} />


        let phase = {
            menuItem: <Menu.Item key='Phase'>
                {this.state.phaseName ?
                    <Popup
                        className="popupStyled"
                        inverted
                        trigger={<span>Phase</span>}
                        content={this.state.phaseName}
                    /> : "Phase"} <Label>{PhaseComponent.length}</Label>
            </Menu.Item>, render: () => <div>
                {searchByName}
                {PhaseComponent && PhaseComponent.length !== 0 ? PhaseComponent : NoReferencesComponent}
            </div>

        }
        let stage = {
            menuItem: isParentActivity && isParentActivity.parentActivity && isParentActivity.parentActivity._id ? <Menu.Item key='Stage'>
                {this.state.stageName ?
                    <Popup
                        className="popupStyled"
                        inverted
                        trigger={<span>Stage</span>}
                        content={this.state.stageName}
                    /> : "Stage"} <Label>{StageComponent.length}</Label>
            </Menu.Item> : null, render: () =>
                <div>
                    {searchByName}
                    {StageComponent && StageComponent.length !== 0 ? StageComponent : NoReferencesComponent}
                </div>
        }
        let act = {
            menuItem: <Menu.Item key='Activity' >
                {this.state.activityName ?
                    <Popup
                        className="popupStyled"
                        inverted
                        trigger={<span>{selectedActivityData.isParentNode ? "Stage" : "Activity"}</span>}
                        content={this.state.activityName}
                    /> : selectedActivityData.isParentNode ? "Stage" : "Activity"}
                <Label>{ActivityComponent.length}</Label>
            </Menu.Item>, render: () => <div>
                {dropingContentComponent}
                {searchByName}
                {ActivityComponent && ActivityComponent.length !== 0 ? ActivityComponent : NoReferencesComponent}
            </div>
        }

        let dropingContentComponent = initiativeData.status === 3 ? null :
            <Container
                style={{
                    margin: '0 0 10px 0',
                    width: '100%', border: '1px dashed #333',
                    padding: '15px 0'
                }}
                groupName="Content"
                behaviour="copy"
                getChildPayload={i => this.state.items[i]}
                onDrop={e => this.onDragEnd(e)}
                shouldAcceptDrop={this.shouldAcceptDrop}>
                <center> Drop content here. </center>
            </Container>



        const panes = []

        if (selectedActivityData.isLeafNode) {
            panes.push(act)
            panes.push(stage)
            panes.push(phase)
        } else if (selectedActivityData.isParentNode) {
            panes.push(act)
            panes.push(phase)
        }


        let showTabs = selectedActivityData.isLeafNode ||
            (selectedActivityData.isParentNode && isParentActivity)


        return (
            <Form className="referenceContainer">

                {showTabs ? null :
                    <React.Fragment>
                        {dropingContentComponent}
                        {searchByName}
                        {this.props.selectedActivityData.references <= 0 ? NoReferencesComponent:""}   
                    </React.Fragment>}


                {selectedActivityData ?
                    showTabs ?
                        <Tab
                            style={{ padding: 0 }}
                            menu={{ secondary: true, pointing: true }}
                            panes={panes}
                            activeIndex={activeIndex}
                            onTabChange={this.handleTabChange}
                            className={isParentActivity && isParentActivity.parentActivity && isParentActivity.parentActivity._id ? "three-block" : "two-block"} /> :
                        ActivityComponent :
                    null}


            </Form>
        )
    }
}

export default CommunityActivityResourcePaneForm
